import { LifeBuoy, Tag } from "lucide-react";

const OPTIONS = [
  { value: "support", label: "Support", Icon: LifeBuoy },
  { value: "subscription_offer", label: "Subscription offer", Icon: Tag },
];

export const PurposeToggle = ({ value, onChange, supportLocked }) => (
  <div data-testid="composer-purpose-toggle" className="inline-flex bg-white border border-slate-200 rounded-md p-0.5 mb-3 ml-2">
    {OPTIONS.map(({ value: v, label, Icon }) => {
      const disabled = v === "support" && supportLocked;
      return (
        <button
          key={v}
          type="button"
          data-testid={`composer-purpose-${v}`}
          onClick={() => !disabled && onChange(v)}
          disabled={disabled}
          aria-pressed={value === v}
          title={disabled ? "AI-origin and promotional drafts retain subscription safeguards. Clear the message before writing a new human support reply." : ""}
          className={`px-3 py-1 text-xs font-semibold rounded transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed ${
            value === v ? (v === "support" ? "bg-slate-900 text-white" : "bg-orange-600 text-white") : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          <Icon className="inline h-3 w-3 mr-1" /> {label}
        </button>
      );
    })}
  </div>
);

export default PurposeToggle;
